"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSortItems = exports.removeInvalidSort = exports.removeSort = exports.getBucketItemIdentifiers = exports.createSorts = exports.getDefaultTreemapSortFromBuckets = exports.getAttributeSortItem = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var every_1 = tslib_1.__importDefault(require("lodash/every"));
var includes_1 = tslib_1.__importDefault(require("lodash/includes"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var isNil_1 = tslib_1.__importDefault(require("lodash/isNil"));
var omitBy_1 = tslib_1.__importDefault(require("lodash/omitBy"));
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sort_1 = require("../constants/sort");
var bucketHelper_1 = require("./bucketHelper");
function getMeasureSortItems(identifier, direction) {
    return [sdk_model_1.newMeasureSort(identifier, direction)];
}
function getAttributeSortItem(identifier, direction, aggregation) {
    if (direction === void 0) { direction = "asc"; }
    if (aggregation === void 0) { aggregation = false; }
    var attributeSortItemWithoutAggregation = {
        attributeIdentifier: identifier,
        direction: direction,
    };
    return {
        attributeSortItem: aggregation
            ? tslib_1.__assign(tslib_1.__assign({}, attributeSortItemWithoutAggregation), { aggregation: "sum" }) : attributeSortItemWithoutAggregation,
    };
}
exports.getAttributeSortItem = getAttributeSortItem;
function getDefaultBarChartSort(insight, canSortStackTotalValue) {
    if (canSortStackTotalValue === void 0) { canSortStackTotalValue = false; }
    var measures = sdk_model_1.insightMeasures(insight);
    var viewBucket = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.VIEW);
    var stackBucket = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.STACK);
    var viewBy = viewBucket ? sdk_model_1.bucketAttributes(viewBucket) : [];
    var stackBy = stackBucket ? sdk_model_1.bucketAttributes(stackBucket) : [];
    if (viewBy.length === 2) {
        if (measures.length >= 2 && !canSortStackTotalValue) {
            return [
                sdk_model_1.newAttributeAreaSort(viewBy[0], sort_1.SORT_DIR_DESC),
                sdk_model_1.newMeasureSort(measures[0], sort_1.SORT_DIR_DESC),
            ];
        }
        return [
            sdk_model_1.newAttributeAreaSort(viewBy[0], sort_1.SORT_DIR_DESC),
            sdk_model_1.newAttributeAreaSort(viewBy[1], sort_1.SORT_DIR_DESC),
        ];
    }
    if (!isEmpty_1.default(viewBy) && !isEmpty_1.default(stackBy)) {
        return [sdk_model_1.newAttributeAreaSort(viewBy[0], sort_1.SORT_DIR_DESC)];
    }
    if (!isEmpty_1.default(viewBy) && canSortStackTotalValue) {
        return [sdk_model_1.newAttributeAreaSort(viewBy[0], sort_1.SORT_DIR_DESC)];
    }
    return isEmpty_1.default(stackBy) && !isEmpty_1.default(measures) ? [sdk_model_1.newMeasureSort(measures[0], sort_1.SORT_DIR_DESC)] : [];
}
function getDefaultTreemapSortFromBuckets(viewBy, segmentBy, measures) {
    var viewAttr = viewBy ? sdk_model_1.bucketAttributes(viewBy) : [];
    var stackAttr = segmentBy ? sdk_model_1.bucketAttributes(segmentBy) : [];
    if (!isEmpty_1.default(viewAttr) && !isEmpty_1.default(stackAttr)) {
        return tslib_1.__spreadArrays([sdk_model_1.newAttributeSort(viewAttr[0], "asc")], measures.map(function (m) { return sdk_model_1.newMeasureSort(m, "desc"); }));
    }
    return [];
}
exports.getDefaultTreemapSortFromBuckets = getDefaultTreemapSortFromBuckets;
function getDefaultTreemapSort(insight) {
    return getDefaultTreemapSortFromBuckets(sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.VIEW), sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.SEGMENT), sdk_model_1.insightMeasures(insight));
}
function getDefaultHeatmapSortFromBuckets(viewBy) {
    var viewAttr = viewBy ? sdk_model_1.bucketAttributes(viewBy) : [];
    if (!isEmpty_1.default(viewAttr)) {
        return [sdk_model_1.newAttributeSort(viewAttr[0], "desc")];
    }
    return [];
}
function getDefaultHeatmapSort(insight) {
    var sorts = sdk_model_1.insightSorts(insight);
    if (sorts && sorts.length > 0) {
        return sorts;
    }
    return getDefaultHeatmapSortFromBuckets(sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.VIEW));
}
// Consider dissolving this function into individual components
function createSorts(type, insight, canSortStackTotalValue) {
    if (canSortStackTotalValue === void 0) { canSortStackTotalValue = false; }
    if (insight.insight.sorts && insight.insight.sorts.length > 0) {
        return insight.insight.sorts;
    }
    switch (type) {
        case sdk_ui_1.VisualizationTypes.COLUMN:
        case sdk_ui_1.VisualizationTypes.LINE:
            return [];
        case sdk_ui_1.VisualizationTypes.BAR:
            return getDefaultBarChartSort(insight, canSortStackTotalValue);
        case sdk_ui_1.VisualizationTypes.TREEMAP:
            return getDefaultTreemapSort(insight);
        case sdk_ui_1.VisualizationTypes.HEATMAP:
            return getDefaultHeatmapSort(insight);
    }
    return [];
}
exports.createSorts = createSorts;
function getBucketItemIdentifiers(referencePoint) {
    var _a;
    var buckets = (_a = referencePoint === null || referencePoint === void 0 ? void 0 : referencePoint.buckets) !== null && _a !== void 0 ? _a : [];
    return buckets.reduce(function (localIdentifiers, bucket) {
        var _a;
        var items = (_a = bucket === null || bucket === void 0 ? void 0 : bucket.items) !== null && _a !== void 0 ? _a : [];
        return localIdentifiers.concat(items.map(function (item) { return item.localIdentifier; }));
    }, []);
}
exports.getBucketItemIdentifiers = getBucketItemIdentifiers;
function isSortItemValid(item, identifiers) {
    var sortIdentifiers = sdk_model_1.sortEntityIds(item);
    return every_1.default(sortIdentifiers.allIdentifiers, function (id) { return includes_1.default(identifiers, id); });
}
function removeSort(referencePoint) {
    if (referencePoint.properties) {
        var properties = omitBy_1.default(tslib_1.__assign(tslib_1.__assign({}, referencePoint.properties), { sortItems: null }), isNil_1.default);
        return tslib_1.__assign(tslib_1.__assign({}, referencePoint), { properties: properties });
    }
    return referencePoint;
}
exports.removeSort = removeSort;
function removeInvalidSort(referencePoint) {
    if (referencePoint.properties) {
        var identifiers_1 = getBucketItemIdentifiers(referencePoint);
        var sortItems = referencePoint.properties.sortItems || [];
        sortItems = sortItems.filter(function (item) {
            return isSortItemValid(item, identifiers_1);
        });
        return tslib_1.__assign(tslib_1.__assign({}, referencePoint), { properties: tslib_1.__assign(tslib_1.__assign({}, referencePoint.properties), { sortItems: sortItems }) });
    }
    return referencePoint;
}
exports.removeInvalidSort = removeInvalidSort;
function setSortItems(referencePoint) {
    var _a, _b;
    var buckets = referencePoint.buckets;
    var sortItems = (_b = (_a = referencePoint === null || referencePoint === void 0 ? void 0 : referencePoint.properties) === null || _a === void 0 ? void 0 : _a.sortItems) !== null && _b !== void 0 ? _b : [];
    if (sortItems.length > 0) {
        return referencePoint;
    }
    var firstMeasure = bucketHelper_1.getFirstValidMeasure(buckets);
    var firstAttribute = bucketHelper_1.getFirstAttribute(buckets);
    if (firstMeasure !== null && firstAttribute == null) {
        set_1.default(referencePoint, ["properties", "sortItems"], getMeasureSortItems(firstMeasure.localIdentifier, sort_1.SORT_DIR_DESC));
    }
    else if (firstAttribute !== null) {
        set_1.default(referencePoint, ["properties", "sortItems"], [getAttributeSortItem(firstAttribute.localIdentifier, sort_1.SORT_DIR_ASC)]);
    }
    return referencePoint;
}
exports.setSortItems = setSortItems;
//# sourceMappingURL=sort.js.map